import { render, staticRenderFns } from "./DepotEventLogTypeSelectComponent.vue?vue&type=template&id=0f8dd869&scoped=true&"
import script from "./DepotEventLogTypeSelectComponent.vue?vue&type=script&lang=ts&"
export * from "./DepotEventLogTypeSelectComponent.vue?vue&type=script&lang=ts&"
import style0 from "./DepotEventLogTypeSelectComponent.vue?vue&type=style&index=0&id=0f8dd869&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8dd869",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCheckbox,VChip,VSelect,VTooltip})
